module.exports = __webpack_public_path__ + "static/media/ht.fb289ca0.svg";